import I18n from '../i18n';

export const stringTypeOfBonus = (bonus: boolean): string => bonus ? I18n.t('free_bet') : I18n.t('bonus');
